import React from 'react';

import { Box, Card, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';
import { FourOhOneKContributionsHeader } from '@betterment/shared-components/src/components/four-oh-one-k-contributions/FourOhOneKContributionsHeader';
import { FourOhOneKContributionsSummary } from '@betterment/shared-components/src/components/four-oh-one-k-contributions/FourOhOneKContributionsSummary';

import { useFourOhOneKContributionsQuery } from './hooks';

import urlBuilder from '../../../../Shared/url-builder';
import { ImpersonationLink } from '../../ImpersonationLink';

export const FourOhOneKContributionOverviewCard: React.FC<{ householdId: string; accountId: string }> = ({
  householdId,
  accountId,
}) => {
  const { isLoading, employeeContributions, employers, clientId } = useFourOhOneKContributionsQuery(
    householdId,
    accountId
  );

  if (isLoading) return <CardLoader />;
  if (!employeeContributions || !employers || !clientId) return null;

  const hasSolo401k: boolean = employers.some(employer => employer.soloFourOhOneKPlan);
  const hasOnlySolo401k: boolean = employers.every(employer => employer.soloFourOhOneKPlan);

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300', width: '100%' }}>
      <Card.Header>
        <FourOhOneKContributionsHeader employers={employers} hasOnlySolo401k={hasOnlySolo401k} />
      </Card.Header>
      <Separator />
      <Card.Content>
        <Box css={{ display: 'grid', gap: 'space.300', marginTop: 'space.25' }}>
          <FourOhOneKContributionsSummary
            employeeContributions={employeeContributions}
            employers={employers}
            hasSolo401k={hasSolo401k}
          />
          <Separator />
          <ImpersonationLink
            showModal={false}
            url={urlBuilder.getImpersonateClientPage.absolute({
              clientId,
              deep_link_path: '/app/four_oh_one_k_details',
            })}
            label="See details"
            variant="textPrimary"
          />
        </Box>
      </Card.Content>
    </Card>
  );
};
